// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("users", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: params.search
      })
        .then(({ data }) => {
          context.commit("set_users", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  list(context, {filter}) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("users",{filter})
        .then(({ data }) => {
          context.commit("set_users", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("users", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      const model = params.model;
      model.shops = params.shops
      NewApiService.put("users/" + model.id, model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  },
  delete(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete("user/" + params.model.id)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
};
